import { render, staticRenderFns } from "./BetterKolmar_et.vue?vue&type=template&id=988052bc"
import script from "./BetterKolmar_et.ts?vue&type=script&lang=ts&external"
export * from "./BetterKolmar_et.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports